module.exports={
    "version": 9,
    "compilerVersion": "1.19.0+commit.72eaeba",
    "contract": "NftSell",
    "md5": "d546c73b76c3a61fd075b09a27a71297",
    "structs": [],
    "library": [
        {
            "name": "ProtoHeader",
            "params": [],
            "properties": [],
            "genericTypes": []
        },
        {
            "name": "NftProto",
            "params": [],
            "properties": [],
            "genericTypes": []
        }
    ],
    "alias": [],
    "abi": [
        {
            "type": "function",
            "name": "unlock",
            "index": 0,
            "params": [
                {
                    "name": "txPreimage",
                    "type": "SigHashPreimage"
                },
                {
                    "name": "nftScript",
                    "type": "bytes"
                },
                {
                    "name": "senderPubKey",
                    "type": "PubKey"
                },
                {
                    "name": "senderSig",
                    "type": "Sig"
                },
                {
                    "name": "nftOutputSatoshis",
                    "type": "int"
                },
                {
                    "name": "op",
                    "type": "int"
                }
            ]
        },
        {
            "type": "constructor",
            "params": [
                {
                    "name": "senderAddress",
                    "type": "Ripemd160"
                },
                {
                    "name": "bsvRecAmount",
                    "type": "int"
                },
                {
                    "name": "nftCodeHash",
                    "type": "bytes"
                },
                {
                    "name": "nftID",
                    "type": "bytes"
                }
            ]
        }
    ],
    "stateProps": [],
    "buildType": "debug",
    "file": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp01/contract/nft/nftSell.scrypt",
    "hex": "0176018801a901ac515301402097dfd76851bf465e8f715593b217714858bbe9570ff3bd5e33840a34e20ff0262102ba79df5f8ae7604a9830f03c7933028186aede0675a16f025dc4f8be8eec0382201008ce7480da41702918d1ec8e6849ba32b4d65b1e40dc669c31a1e6306b266c5479547985011455930079012493007901149300795893007958930079011493007901249300795293<senderAddress><bsvRecAmount><nftCodeHash><nftID>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",
    "sourceMapFile": "file:///Users/ivan/Codes/blockchain/meta-contract/src/mcp01/contract-desc/nftSell.map.json"
}